import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = getLatestArticles(8);

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新文章</h2>
            <p className="mt-2 text-sm text-foreground-600">持续更新，不错过任何精彩内容</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-100 hover:bg-accent-50/50 transition-colors"
            >
              <div className="w-[140px] h-[100px] flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-2">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {article.category === 'keji' ? '科技' :
                     article.category === 'shenghuo' ? '生活' :
                     article.category === 'yule' ? '娱乐' :
                     article.category === 'caijing' ? '财经' :
                     article.category === 'jiaoyu' ? '教育' : '健康'}
                  </span>
                  <span className="text-[11px] text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}